import React from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ClearIcon from '@mui/icons-material/Clear';
import { Box, TextField, Button, Typography, Chip, IconButton, CircularProgress } from '@mui/material';

const MobileUrlInput = ({ 
  url,
  onUrlChange,
  videoTitle,
  onTitleClear,
  onAnalyzeClick,
  isAnalyzePage,
  isProcessing,
  t
}) => {
  return (
    <Box sx={{ px: 2, pb: 1 }}>
      {/* URL 입력 필드 */}
      <TextField
        fullWidth
        variant="outlined"
        placeholder={t('header.urlPlaceholder')}
        value={url}
        onChange={onUrlChange}
        size="small"
        sx={{
          mb: 1,
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#f8f9fa',
            fontSize: 14,
            '&:hover': { backgroundColor: '#f1f3f4' },
            '&.Mui-focused': { backgroundColor: '#fff' }
          }
        }}
      />

      {/* 비디오 제목 표시 */}
      {videoTitle && (
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1, 
          mb: 1,
          p: 1,
          backgroundColor: '#e3f2fd',
          borderRadius: 1,
          border: '1px solid #bbdefb'
        }}>
          <Typography 
            variant="body2" 
            sx={{ 
              flex: 1, 
              fontSize: 13, 
              color: '#1565c0',
              fontWeight: 500,
              lineHeight: 1.3
            }}
          >
            {videoTitle}
          </Typography>
          <Chip
            icon={<ClearIcon />}
            label={t('common.clear')}
            onClick={onTitleClear}
            size="small"
            variant="outlined"
            sx={{
              height: 24,
              fontSize: 11,
              color: '#1565c0',
              borderColor: '#1565c0',
              '&:hover': { backgroundColor: '#bbdefb' }
            }}
          />
        </Box>
      )}

      {/* 분석 버튼 */}
      {isAnalyzePage && (
        <Button
          fullWidth
          variant="contained"
          startIcon={<PlayArrowIcon />}
          onClick={onAnalyzeClick}
          disabled={!url.trim() || isProcessing}
          sx={{
            height: 40,
            fontSize: 14,
            fontWeight: 600,
            backgroundColor: '#1976d2',
            '&:hover': { backgroundColor: '#1565c0' },
            '&:disabled': { 
              backgroundColor: '#e0e0e0',
              color: '#9e9e9e'
            }
          }}
        >
          {isProcessing ? t('common.processing') : t('header.analyze')}
        </Button>
      )}
    </Box>
  );
};

export default MobileUrlInput; 